import { RouteLocationNormalized } from "vue-router";
import { centerResolver } from "./center.resolver";
import { zonesResolver } from "./zones.resolver";

export const centerWithZonesResolver = async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    try {
        await Promise.all([centerResolver(to, from), zonesResolver(to, from)]);
    } catch(error) {
        console.error('CENTER_WITH_ZONES_RESOLVER_ERROR');
        return { name: 'SystemCenters' };
    }
}